import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';

@Injectable()
export class CuepidDateAdapter extends NativeDateAdapter {
  getDateNames(): string[] {
    return [...Array(31)].map((_, i) => `${i + 1}`);
  }
}
